import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsReasonTypes } from '../../data-provider/select-options';

export const useGetPreClaimsReasonTypeList = () => {
  return useQuery({
    queryKey: ['pre-claims-reason-type-list'],
    queryFn: () => fetchPreClaimsReasonTypes(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
